var lib_core = require("lib-core");

var LoadingWatchdogStatemachine = function (root, model){
    this.root = root;

    lib_core.StateMachine.call(this, null, null, model.scope());

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.APP_LOADED;
        },
        function(cEvent){
            clearTimeout(model.watchdog);
        }
    );

};

lib_core.inherit(LoadingWatchdogStatemachine, lib_core.StateMachine);

module.exports = LoadingWatchdogStatemachine;
